var $ = require('jquery');
var fitvids = require('fitvids');

$('.block-type--embed').each(function() {
    fitvids($(this));
})